import Vue from 'vue'
import Popover from 'vue-js-popover'
 
Vue.use(Popover)